import { render } from "./DocsPersonalData.vue?vue&type=template&id=19f371f3"
import script from "./DocsPersonalData.vue?vue&type=script&lang=js"
export * from "./DocsPersonalData.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DocsPersonalData.vue?vue&type=style&index=0&id=19f371f3&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__